const FALLBACK = '/';

const BLOCKED_EXACT = new Set([
  '/login',
  '/signup',
  '/reset-password',
  '/auth/callback',
  '/auth/complete-profile',
]);

const decodeRepeatedly = (value) => {
  let current = value;
  for (let i = 0; i < 3; i += 1) {
    try {
      const decoded = decodeURIComponent(current);
      if (decoded === current) break;
      current = decoded;
    } catch {
      return null;
    }
  }
  return current;
};

const hasDangerousProtocol = (value) => {
  const lower = value.toLowerCase();
  const scriptProto = ['java', 'script', ':'].join('');
  const dataProto = `data:`;
  const vbProto = `vbscript:`;
  return (
    lower.startsWith(scriptProto) ||
    lower.startsWith(dataProto) ||
    lower.startsWith(vbProto) ||
    lower.slice(1).startsWith(scriptProto) ||
    lower.includes(scriptProto) ||
    lower.includes(dataProto) ||
    lower.includes(vbProto)
  );
};

/**
 * Sanitise a post-login return path from query params or router state.
 * Allows same-origin internal paths only; otherwise returns `/`.
 */
export const safeReturnPath = (raw) => {
  if (raw == null) return FALLBACK;

  const decoded = decodeRepeatedly(String(raw).trim());
  if (decoded == null) return FALLBACK;

  const value = decoded.trim();
  if (!value) return FALLBACK;
  if (!value.startsWith('/')) return FALLBACK;
  if (/^\/{2,}/.test(value)) return FALLBACK;
  if (value.includes('\\')) return FALLBACK;
  if (value.includes('\0') || value.includes('\r') || value.includes('\n')) return FALLBACK;
  if (value.includes('://')) return FALLBACK;
  if (hasDangerousProtocol(value)) return FALLBACK;

  const pathOnly = value.split('?')[0].split('#')[0];
  if (!pathOnly.startsWith('/') || /^\/{2,}/.test(pathOnly)) return FALLBACK;
  if (BLOCKED_EXACT.has(pathOnly) || pathOnly.startsWith('/auth/')) {
    return FALLBACK;
  }

  return value;
};

export const loginRedirectWithFrom = (pathname, search = '') => {
  const candidate = `${pathname || ''}${search || ''}`;
  const safe = safeReturnPath(candidate);
  if (!safe || safe === '/') return '/login';
  return `/login?from=${encodeURIComponent(safe)}`;
};

export default safeReturnPath;
